import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"background-color":"rgba(0,0,0,0.5)"}
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Confirmação", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "×", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Tem certeza que deseja continuar?")
], -1)
const _hoisted_9 = { class: "modal-footer" }
const _hoisted_10 = { class: "card" }
const _hoisted_11 = { class: "card-body px-0 pt-0 pb-2" }
const _hoisted_12 = { class: "table-responsive p-0" }
const _hoisted_13 = { class: "table align-items-center mb-0" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Rota"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Veículo"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Motorista"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Serviços"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2" }, "Distancia"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2" }, "Fixa"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2" }, "Confirmada")
  ])
], -1)
const _hoisted_15 = { class: "d-flex px-2 py-1" }
const _hoisted_16 = {
  class: "align-middle text-center rota",
  style: {"display":"flex"}
}
const _hoisted_17 = { class: "stepper" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { style: {"font-size":"8px"} }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-flag" }, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "align-middle text-center" }
const _hoisted_28 = {
  key: 0,
  class: "badge badge-danger"
}
const _hoisted_29 = { key: 1 }
const _hoisted_30 = {
  key: 0,
  class: "badge badge-danger"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", null, "Atualizando", -1)
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onUpdate:modelValue", "onChange"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Selecione um veículo", -1)
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "align-middle text-center" }
const _hoisted_39 = {
  key: 0,
  class: "badge badge-danger"
}
const _hoisted_40 = { key: 1 }
const _hoisted_41 = {
  key: 0,
  class: "badge badge-danger"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", null, "Atualizando", -1)
const _hoisted_44 = [
  _hoisted_42,
  _hoisted_43
]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onUpdate:modelValue", "onChange"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Selecione um motorista", -1)
const _hoisted_48 = ["value"]
const _hoisted_49 = { class: "text-center text-xs font-weight-bold mb-0" }
const _hoisted_50 = { class: "text-center text-xs text-secondary mb-0" }
const _hoisted_51 = { class: "align-middle text-center text-sm" }
const _hoisted_52 = { class: "badge badge-sm bg-gradient-success" }
const _hoisted_53 = { class: "align-middle text-center text-sm" }
const _hoisted_54 = { class: "form-check form-switch" }
const _hoisted_55 = ["onChange", "onUpdate:modelValue"]
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexSwitchCheckDefault"
}, null, -1)
const _hoisted_57 = { class: "align-middle text-center text-sm" }
const _hoisted_58 = {
  key: 0,
  class: "form-check form-switch"
}
const _hoisted_59 = ["onChange", "onUpdate:modelValue"]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexSwitchCheckDefault"
}, null, -1)
const _hoisted_61 = {
  key: 1,
  class: "badge badge-lg bg-gradient-success"
}
const _hoisted_62 = { class: "text-sm" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-sync text-secondary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_67 = ["onClick"]
const _hoisted_68 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-trash text-secondary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_71 = ["onClick"]
const _hoisted_72 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-box text-secondary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_73 = [
  _hoisted_72
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueDraggable = _resolveComponent("VueDraggable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($data.showConfirmModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.showConfirmModal = false))
                }, _hoisted_7)
              ]),
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: "btn btn-secondary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($data.showConfirmModal = false))
                }, "Cancelar"),
                _createElementVNode("button", {
                  class: "btn btn-danger",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirmAction && _ctx.confirmAction(...args)))
                }, "Confirmar")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("table", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.rotas, (rota) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", null, _toDisplayString(rota.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          ($props.map)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                onClick: ($event: any) => ($setup.toggleUnicRoute(rota)),
                                class: "step icon",
                                style: _normalizeStyle({ backgroundColor: rota.color,  opacity: 1})
                              }, _hoisted_20, 12, _hoisted_18))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: "step icon",
                            style: _normalizeStyle({ backgroundColor: rota.color,  opacity: 0.5})
                          }, _hoisted_22, 4),
                          _createVNode(_component_VueDraggable, {
                            ref_for: true,
                            ref: "el",
                            disabled: rota.confirmada,
                            modelValue: rota.Pedidos,
                            "onUpdate:modelValue": ($event: any) => ((rota.Pedidos) = $event),
                            animation: 150,
                            ghostClass: "ghost",
                            style: {"display":"flex"},
                            onStart: $setup.onStart,
                            onUpdate: $setup.onUpdate,
                            onEnd: (evt) => $setup.onEnd(evt, rota.id)
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rota.Pedidos, (pedido, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: pedido.ordem,
                                  onClick: ($event: any) => ($setup.setCenterItem(pedido)),
                                  class: _normalizeClass(['step', $setup.getClassByStatus(pedido.status_entrega),  pedido === 'Intervalo' ? 'interval' : ''])
                                }, [
                                  _createElementVNode("span", _hoisted_24, _toDisplayString(pedido.numero_pedido), 1)
                                ], 10, _hoisted_23))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["disabled", "modelValue", "onUpdate:modelValue", "onStart", "onUpdate", "onEnd"]),
                          _createElementVNode("div", {
                            class: "step icon",
                            style: _normalizeStyle({ backgroundColor: rota.color,  opacity: 0.5})
                          }, _hoisted_26, 4)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_27, [
                    (!rota.editingVeiculo)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (!rota.id_veiculo)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, " SEM VEÍCULO "))
                            : (_openBlock(), _createElementBlock("span", _hoisted_29, [
                                (rota.Veiculo.is_update)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, _hoisted_33))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(rota.Veiculo?.marca), 1)
                              ])),
                          _createElementVNode("i", {
                            class: "fas fa-user-edit text-secondary",
                            style: {"cursor":"pointer"},
                            onClick: ($event: any) => (rota.editingVeiculo = true)
                          }, null, 8, _hoisted_34)
                        ], 64))
                      : _withDirectives((_openBlock(), _createElementBlock("select", {
                          key: 1,
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((rota.id_veiculo) = $event),
                          onChange: ($event: any) => ($setup.alocarVeiculo(rota.id_veiculo, rota.id, rota.id_veiculo, rota  ))
                        }, [
                          _hoisted_36,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.veiculos, (m) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: m.id,
                              value: m.id
                            }, _toDisplayString(m.marca), 9, _hoisted_37))
                          }), 128))
                        ], 40, _hoisted_35)), [
                          [_vModelSelect, rota.id_veiculo]
                        ])
                  ]),
                  _createElementVNode("td", _hoisted_38, [
                    (!rota.editingOperador)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (!rota.operador_id)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_39, " SEM MOTORISTA "))
                            : (_openBlock(), _createElementBlock("span", _hoisted_40, [
                                (rota.operador.is_update)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_41, _hoisted_44))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(rota.operador?.nome_completo), 1)
                              ])),
                          _createElementVNode("i", {
                            class: "fas fa-user-edit text-secondary",
                            style: {"cursor":"pointer"},
                            onClick: ($event: any) => (rota.editingOperador = true)
                          }, null, 8, _hoisted_45)
                        ], 64))
                      : _withDirectives((_openBlock(), _createElementBlock("select", {
                          key: 1,
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((rota.operador_id) = $event),
                          onChange: ($event: any) => ($setup.alocarMotorista(rota.Veiculo.id, rota.id, rota.operador_id, rota  ))
                        }, [
                          _hoisted_47,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.motoristas, (m) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: m.id,
                              value: m.id
                            }, _toDisplayString(m.nome_completo), 9, _hoisted_48))
                          }), 128))
                        ], 40, _hoisted_46)), [
                          [_vModelSelect, rota.operador_id]
                        ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("p", _hoisted_49, _toDisplayString(rota.Pedidos.length), 1),
                    _createElementVNode("p", _hoisted_50, _toDisplayString(rota.primary_category_id), 1)
                  ]),
                  _createElementVNode("td", _hoisted_51, [
                    _createElementVNode("span", _hoisted_52, _toDisplayString(rota.distance) + " Km", 1)
                  ]),
                  _createElementVNode("td", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "flexSwitchCheckDefault",
                        onChange: ($event: any) => ($setup.salvarRota(rota)),
                        "onUpdate:modelValue": ($event: any) => ((rota.fixa) = $event)
                      }, null, 40, _hoisted_55), [
                        [_vModelCheckbox, rota.fixa]
                      ]),
                      _hoisted_56
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_57, [
                    (!rota.confirmada)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            id: "flexSwitchCheckDefault",
                            onChange: ($event: any) => ($setup.salvarRota(rota)),
                            "onUpdate:modelValue": ($event: any) => ((rota.confirmada) = $event)
                          }, null, 40, _hoisted_59), [
                            [_vModelCheckbox, rota.confirmada]
                          ]),
                          _hoisted_60
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_61, "CONFIRMADA"))
                  ]),
                  _createElementVNode("td", _hoisted_62, [
                    _createElementVNode("a", {
                      href: "javascript:;",
                      onClick: ($event: any) => ($props.reprocessOrdem(rota, true)),
                      "data-bs-toggle": "tooltip",
                      "data-bs-original-title": "Ordem Padrão"
                    }, _hoisted_65, 8, _hoisted_63),
                    _hoisted_66,
                    _createElementVNode("a", {
                      href: "javascript:;",
                      onClick: ($event: any) => ($setup.removerRota(rota)),
                      "data-bs-toggle": "tooltip",
                      "data-bs-original-title": "Apagar Rota"
                    }, _hoisted_69, 8, _hoisted_67),
                    _hoisted_70,
                    _createElementVNode("a", {
                      href: "javascript:;",
                      onClick: ($event: any) => ($props.arquivarRota(rota)),
                      "data-bs-toggle": "tooltip",
                      "data-bs-original-title": "Arquivar Rota"
                    }, _hoisted_73, 8, _hoisted_71)
                  ])
                ]))
              }), 256))
            ])
          ])
        ])
      ])
    ])
  ], 64))
}